import { Requests } from "../common/request.common";
import { GroupResponseTypes } from "../common/response.common";
import { SelectParam } from "../common/types.common";
import { buildSelectParam, get, post } from "./common";

export const group = {
    record(data: typeof Requests.Group.Record.Input) {
        return post<typeof data, GroupResponseTypes.Record>("/group/record", data);
    },
    add(data: typeof Requests.Group.Create.Input) {
        return post<typeof data>("/group/create", data);
    },
    obtain(id: string) {
        return get<GroupResponseTypes.Obtain>(`/group/obtain/${id}`);
    },
    uaRecord(id: string) {
        return (data: typeof Requests.Group.UARecord.Input) =>
            post<typeof data, GroupResponseTypes.UARecord>(`/group/ua-record/${id}`, data);
    },
    uaAdd(id: string, data: typeof Requests.Group.UAAdd.Input) {
        return post<typeof data>(`/group/ua-add/${id}`, data);
    },
    uaRemove(id: string, data: typeof Requests.Group.UARemove.Input) {
        return post<typeof data>(`/group/ua-remove/${id}`, data);
    },
    exportUser(id: string) {
        return get(`/group/export-user/${id}`, {
            authenticated: true,
            downloadable: true,
            responseType: "arraybuffer",
        });
    },
    optionAll: async (params: SelectParam) => {
        return (
            (await get<GroupResponseTypes.OptionAll>(
                "/group/option/all" + buildSelectParam(params),
            ).execute()) ?? []
        );
    },
    optionByUser: async (userAttendanceId: string) => {
        return (
            (await get<GroupResponseTypes.OptionByUser>(
                `/group/option/by-user/${userAttendanceId}`,
            ).execute()) ?? []
        );
    },
    optionByUserDevice: async (userAttendanceId: string, deviceId: string) => {
        return (
            (await get<GroupResponseTypes.OptionByUserDevice>(
                `/group/option/by-user-device/${userAttendanceId}/${deviceId}`,
            ).execute()) ?? []
        );
    },
    optionExcludeByDevice: async (deviceId: string) => {
        return (
            (await get<GroupResponseTypes.OptionExcludeByDevice>(
                `/group/option-exclude/by-device/${deviceId}`,
            ).execute()) ?? []
        );
    },
};
